// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"85ea6947","455":"bbb916f2","512":"68a29377","585":"9b262862","735":"e2779ab1","836":"cbe65981","840":"b457c933","857":"c57e6c83","885":"3977cef0","890":"3b99554f","977":"782f225d"}[chunkId] + ".chunk.js";
};